import { z } from "zod";

const ConfigSchema = z.object({
  authServerUrl: z.url().transform((u) => u.replace(/\/$/, "")),
  clientId: z.string().min(1).default("platform-console"),
  docsBaseUrl: z.string().default("https://github.com/your-org/auth-platform/blob/main/docs"),
  timeZone: z.string().default("Asia/Bangkok"),
});

export type RuntimeConfig = z.infer<typeof ConfigSchema>;

/** Runtime config from /config.json so one static build works in any environment. */
export async function loadConfig(): Promise<RuntimeConfig> {
  const res = await fetch("/config.json", { cache: "no-store" });
  if (!res.ok) throw new Error(`Cannot load /config.json (${res.status})`);
  return ConfigSchema.parse(await res.json());
}

export function parseConfig(input: unknown): RuntimeConfig {
  return ConfigSchema.parse(input);
}
